import { store } from '~/store';

export default function interceptorRequest(config) {
  const { auth } = store.getState();
  if (auth && auth.token) config.headers.Authorization = `Bearer ${auth.token}`;
  return config;
}
